import { Instagram, Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const explore = [
  { label: "Our Facility", href: "#kitchens" },
  { label: "The Difference", href: "#difference" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Corridor Walk", href: "#gallery" },
  { label: "Partner With Us", href: "#contact" },
];

const MAPS_URL = "https://maps.google.com/?q=Dubai+Investment+Park+Phase+2,+Dubai,+UAE";

export default function Footer() {
  const go = (e, href) => { e.preventDefault(); scrollToId(href); };
  return (
    <footer className="border-t border-gold/15 bg-[#0e0e10]" data-testid="footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:grid-cols-2 md:px-8 lg:grid-cols-4">
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-gold">Explore</p>
          <ul className="mt-5 space-y-3">
            {explore.map((l) => (
              <li key={l.href}>
                <a href={l.href} onClick={(e) => go(e, l.href)} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-xs text-white/60 transition-colors duration-300 hover:text-gold">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-gold">Facility</p>
          <ul className="mt-5 space-y-3 text-xs text-white/60">
            <li>
              <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-location-link" className="flex items-start gap-2 transition-colors duration-300 hover:text-gold">
                <MapPin size={12} className="mt-0.5 shrink-0 text-gold" /> DIP Phase 2, Plot 597–775, Off Expo 2020 Road, Dubai, UAE
              </a>
            </li>
            <li>
              <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-directions-link" className="flex items-center gap-2 transition-colors duration-300 hover:text-gold">
                <ArrowUpRight size={12} className="text-gold" /> Get Directions
              </a>
            </li>
            <li className="pt-1 text-[11px] font-light leading-relaxed text-white/45">
              Catchment: Dubai South · Al Furjan · Green Community · Jebel Ali Village · JBR
            </li>
          </ul>
        </div>
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-gold">Contact</p>
          <ul className="mt-5 space-y-3 text-xs text-white/60">
            <li>
              <a href="tel:+97148858977" data-testid="footer-phone-link" className="flex items-center gap-2 transition-colors duration-300 hover:text-gold">
                <Phone size={12} className="text-gold" /> 04 885 8977
              </a>
            </li>
            <li>
              <a href="https://wa.me/971529292511" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="flex items-center gap-2 transition-colors duration-300 hover:text-gold">
                <Phone size={12} className="text-gold" /> WhatsApp · 052 929 2511
              </a>
            </li>
            <li>
              <a href="mailto:arun@rmefandbeqpt.com" data-testid="footer-email-link" className="flex items-center gap-2 transition-colors duration-300 hover:text-gold">
                <Mail size={12} className="text-gold" /> arun@rmefandbeqpt.com
              </a>
            </li>
          </ul>
        </div>
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-gold">Follow Us</p>
          <div className="mt-5 flex gap-3">
            <a
              href="https://www.instagram.com/royalexpresscloudkitchen/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-social-instagram"
              aria-label="Royal Express Cloud Kitchen on Instagram"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-gold/30 text-gold transition-all duration-500 hover:bg-gold hover:text-black"
            >
              <Instagram size={16} />
            </a>
            <a
              href="https://www.instagram.com/royalexpresscloudkitchen/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-handle"
              className="flex items-center text-xs text-white/60 transition-colors duration-300 hover:text-gold"
            >
              @royalexpresscloudkitchen
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-gold/10" data-testid="footer-copyright">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-5 py-6 md:px-8">
          <img src="/assets/brand/logo.webp" alt="Royal Express Cloud Kitchen logo" className="h-12 w-auto mix-blend-screen" data-testid="footer-logo" />
          <p className="text-[10px] uppercase tracking-[0.24em] text-white/40">
            © 2026 Royal Express Cloud Kitchen · Dubai, UAE · All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
}
